"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = exports.interpolate = void 0;
var luxon_1 = require("luxon");
exports.interpolate = function (str, obj) { return str.replace(/\${(.*?)}/g, function (_, g) { return obj[g]; }); };
exports.formatDate = function (date) {
    return luxon_1.DateTime.fromISO(date).toLocaleString(luxon_1.DateTime.DATETIME_MED);
};
